import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import moment from 'moment';
import {Link} from 'react-router-dom';

//img
import noNewsImg from '../../assets/icons/examples-bg.png';

const MainPageNews = ({ clang, data }) => {

    const verticalOrient = {
        WebkitBoxOrient: 'vertical'
    };

    return (
        <article className="main-news">
            <div className="main-news__container">
                <Link className="main-news__header" to={`/news/all`}>
                    {lang[clang].main_page.news}
                </Link>
                <ul className="main-news__list">
                    {data.map((dataItem, index) =>
                        <li key={index} className="main-news__list-item">
                            <Link to={`/news/all/${dataItem.id}`} title={lang[clang].read_more} className="main-news__list-item--link">
                                <div className="main-news__tag">{lang[clang].main_page[dataItem.categories[0]]}</div>
                                <div className="main-news__img" style={{backgroundImage: "url(" + (dataItem.better_featured_image !== null ? dataItem.better_featured_image.source_url : noNewsImg) + ")"}}></div>
                                <span className="main-news__circle"></span>
                                <span className="main-news__line"></span>
                                <div className="main-news__info">
                                    <h3 dangerouslySetInnerHTML={{__html: dataItem.title.rendered}} className="main-news__title" style={verticalOrient}>
                                    </h3>
                                    <p className="main-news__date">{moment(dataItem.date).format('DD/MM/YYYY')}</p>
                                    <p className="main-news__desc" dangerouslySetInnerHTML={{__html: dataItem.acf.news_post_desc}} style={verticalOrient}></p>
                                    <button className="main-news__btn" tabIndex="-1">
                                        {lang[clang].read_more}
                                        <span className="main-news__btn-icon"></span>
                                    </button>
                                </div>
                            </Link>
                        </li>)}
                </ul>
                <Link to={`/news`} title={lang[clang].main_page.news_all} className="main-news__all-button">
                    {lang[clang].main_page.news_all}
                    <span className="main-news__all-button__img"></span>
                </Link>
            </div>


        </article>
    );
};

MainPageNews.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(MainPageNews);



// WEBPACK FOOTER //
// ./src/components/main-page/MainPageNews.js